/*
 * CUSTOM REVIEWS — client-side interactivity (no app, no backend).
 * 1. Helpful votes: click to +1, persisted in localStorage so it survives
 *    refresh AND logout (localStorage is per-browser, not tied to a login).
 *    Re-click toggles off; up/down are mutually exclusive.
 * 2. Read more: clamps long review text and reveals it on demand.
 */
(function () {
  function initVotes() {
    document.querySelectorAll('.cr__vote[data-cr-key]').forEach(function (btn) {
      var key = 'crv:' + btn.getAttribute('data-cr-key');
      var base = parseInt(btn.getAttribute('data-base'), 10) || 0;
      var countEl = btn.querySelector('.cr__vote-count');
      var voted = localStorage.getItem(key) === '1';

      function render() {
        btn.classList.toggle('is-voted', voted);
        btn.setAttribute('aria-pressed', voted ? 'true' : 'false');
        if (countEl) countEl.textContent = base + (voted ? 1 : 0);
      }
      render();

      btn.addEventListener('click', function () {
        voted = !voted;
        if (voted) {
          localStorage.setItem(key, '1');
          // up/down mutually exclusive within the same review
          var group = btn.closest('.cr__helpful');
          if (group) {
            group.querySelectorAll('.cr__vote[data-cr-key]').forEach(function (other) {
              if (other !== btn && other.classList.contains('is-voted')) {
                var okey = 'crv:' + other.getAttribute('data-cr-key');
                localStorage.removeItem(okey);
                other.classList.remove('is-voted');
                other.setAttribute('aria-pressed', 'false');
                var oc = other.querySelector('.cr__vote-count');
                if (oc) oc.textContent = parseInt(other.getAttribute('data-base'), 10) || 0;
              }
            });
          }
        } else {
          localStorage.removeItem(key);
        }
        render();
      });
    });
  }

  function initReadMore() {
    document.querySelectorAll('.cr__text').forEach(function (p) {
      p.classList.add('cr__text--clamped');
      // if it doesn't actually overflow, leave it fully visible
      if (p.scrollHeight - p.clientHeight < 4) {
        p.classList.remove('cr__text--clamped');
        return;
      }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cr__readmore';
      btn.textContent = 'Read more';
      btn.addEventListener('click', function () {
        var clamped = p.classList.toggle('cr__text--clamped');
        btn.textContent = clamped ? 'Read more' : 'Read less';
      });
      p.insertAdjacentElement('afterend', btn);
    });
  }

  function init() {
    initVotes();
    initReadMore();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
